import { defaultTheme } from 'react-admin';

export const koelTheme = {
  name: 'koel',
  logo: 'koel.jpeg',
  palette: {
    primary: {
      main: '#0082c6',
      dark: '#233c71',
    },
    secondary: {
      light: '#5f5fc4',
      main: '#283593',
      dark: '#233c71',
      contrastText: '#fff',
    },
    background: {
      default: '#fcfcfe',
    },
    mode: 'light' as 'light',
  },
  shape: {
    borderRadius: 2,
  },
  components: {
    ...defaultTheme.components,
    RaMenuItemLink: {
      styleOverrides: {
        root: {
          'color': '#aaa',
          'borderLeft': '3px solid #0078bf',
          '&.RaMenuItemLink-active': {
            'borderLeft': '3px solid #fff',
            'color': '#fff',
            '& .RaMenuItemLink-icon': {
              color: '#fff',
            },
          },
          '& .RaMenuItemLink-icon': {
            color: '#aaa',
          },
        },
      },
    },
    RaFileInput: {
      styleOverrides: {
        root: {
          '& .RaFileInput-dropZone': { background: '#f5f5f5' },
        },
      },
    },
    RaImageInput: {
      styleOverrides: {
        root: {
          '& .RaFileInput-dropZone': { background: '#f5f5f5' },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        colorSecondary: {
          color: '#fff',
          backgroundColor: '#0078bf',
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: {
          backgroundColor: '#0078bf',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: 'none',
        },
        root: {
          backgroundClip: 'padding-box',
        },
      },
    },
  },
};
